export interface AuthResponse {
  id_token: string;
  userId: string;
  isProfileComplete: boolean;
  isActive:boolean;
  status:boolean
}
